/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Goodforownhint3Inputs */

const en_goodforownhint3 = /** @type {(inputs: Goodforownhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick up to 3 occasions. This helps place your venue correctly but is never shown as a label by itself.`)
};

const de_goodforownhint3 = /** @type {(inputs: Goodforownhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle bis zu 3 Anlässe. Das hilft, deinen Ort richtig einzuordnen, wird aber nie selbst als Label gezeigt.`)
};

/**
* | output |
* | --- |
* | "Pick up to 3 occasions. This helps place your venue correctly but is never shown as a label by itself." |
*
* @param {Goodforownhint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const goodforownhint3 = /** @type {((inputs?: Goodforownhint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Goodforownhint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_goodforownhint3(inputs)
	return de_goodforownhint3(inputs)
});
export { goodforownhint3 as "goodForOwnHint" }